<header-title [model]="headerTitle"></header-title>

<section class="card mt-4">
    <header class="card-header">
        <h3 class="text-gray-600 m-0"><i class="fas fa-tasks"></i>Update Lender</h3>
    </header>
    <div class="card-body py-5">
        <div class="container">
            <div class="tab-navigation">
                <nav>
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a class="nav-link active text-primary">
                                <i class="fas fa-building" aria-hidden="true"></i>Lender Details
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link text-muted" [routerLink]="['/lenders', 'contact', lenderId]">
                                <i class="fas fa-users" aria-hidden="true"></i>Contact Details
                            </a>
                        </li>
                    </ul>
                </nav>
            </div>
            <form [formGroup]="editLenderFormGroup" *ngIf="editLenderFormGroup" (submit)="editLender()">
                <div class="row mt-3">
                    <div class="col-12 text-end">
                        <button class="btn btn-outline-primary ms-2" type="button" (click)="onBack()" *ngIf="!isEditMode">Back</button>
                        <button class="btn btn-primary ms-2" type="button" (click)="toggleEditMode()" *ngIf="!isEditMode">Edit</button>
                        <button class="btn btn-outline-primary ms-2" type="button" (click)="toggleEditMode()" *ngIf="isEditMode">Cancel</button>
                        <button class="btn btn-danger ms-2" type="button" *ngIf="isEditMode && !hasContacts" (click)="confirmation.showMessage();">Delete Lender</button>
                        <button class="btn btn-danger ms-2" type="button" *ngIf="isEditMode && hasContacts" (click)="openCannotDeleteLender(cannotDeleteLender);">Delete Lender</button>
                        <button class="btn btn-success ms-2" type="submit" [disabled]="!editLenderFormGroup.valid" *ngIf="isEditMode">Save</button>
                    </div>
                </div>
                <error-message [errors]="errors"></error-message>
                <div class="card bg-success text-primary mt-3" *ngIf="infoMessage">
                    <div class="card-body">{{infoMessageText}}</div>
                </div>
                <h4 class="mt-5 text-primary">Lender Details</h4>
                <div class="row mt-3">
                    <div class="col-md-6 col-lg-4">
                        <div class="form-group">
                            <input type="hidden" class="form-control" formControlName="id" />
                            <label class="control-label">
                                Name
                            </label>
                            <input type="text" class="form-control" formControlName="name" [readOnly]="!isEditMode" />
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</section>


<app-confirmation-message #confirmation (confirmationClicked)="deleteLender();"
                          [title]="'Confirmation'"
                          [message]="'Are you sure you want to remove this Lender?'">
</app-confirmation-message>

<ng-template #cannotDeleteLender let-modal>
    <div class="modal-header">
        <div class="container">
            <div class="row">
                <div class="col-10">
                    <div class="row">
                        <div class="col-12">
                            <h4 class="modal-title" id="modal-basic-title">Lenders with assigned contacts cannot be deleted.</h4>
                        </div>
                        <div class="col-12">
                            <p id="modal-basic-content">Remove all contacts to continue.</p>
                        </div>
                    </div>
                </div>
                <div class="col-2">
                    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</ng-template>
